import { convertAndAddToObject } from "./convertAndAddToObject";

export function convertToBooleanAndAddToObject<T, U>(
	obj: T,
	value: U,
	key: keyof T
) {
	return convertAndAddToObject(obj, value, key, value => !!value);
}
